import React, { useState, useEffect } from 'react';
import Ajv from 'ajv';

import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';
import { callApi } from 'api/helpers/api.helpers';
import userApi from '../../../api/user.api';
import AssistiveText from '../../submission/templates/AssistiveText';
import TextWidget from '../../submission/templates/TextWidget';

const useStyles = makeStyles(() => ({
  input: {
    width: '100%',
  },
}));

export default function UserEmailWidget(props) {
  const [backendValidation, setBackendValidation] = useState({ ERROR: null });
  const [hasSchemaErrors, setHasSchemaErrors] = useState(false);
  const { onChange, rawErrors = [], schema = {}, registry, value } = props;

  const { t } = useTranslation();
  const ajv = new Ajv();

  useEffect(() => {
    // Triggers validation on init
    onChange(value);
  }, []);

  const onChangeDebounced = async (id, newValue) => {
    onChange(newValue);

    const validByJsonSchema = ajv.validate(schema, newValue);
    setHasSchemaErrors(!validByJsonSchema);

    if (validByJsonSchema) {
      await callApi(userApi.validateEmail, {
        showAlertOnError: false,
        onSuccess: () => {
          registry.forceValidityState(false);
          setBackendValidation({ ERROR: t('user.email.duplicated') });
        },
        onError: () => {
          registry.forceValidityState(true);
          setBackendValidation({ ERROR: null });
        },
      })(newValue);
    } else {
      registry.forceValidityState(true);
      setBackendValidation({ ERROR: null });
    }
  };

  const classes = useStyles();
  const hasErrors = hasSchemaErrors || !!backendValidation?.ERROR;
  return (
    <div>
      <TextWidget
        {...props}
        className={classes.input}
        hasError={hasErrors}
        onBlur={onChangeDebounced}
        error={rawErrors.length > 0}
      />
      {!!backendValidation?.ERROR && <AssistiveText severity="error">{t(backendValidation?.ERROR)}</AssistiveText>}
    </div>
  );
}
